export const ROW_SELECTOR_PLACEHOLDERS = [
  'COLOR',
  'SIZE',
  'PRICE RANGE',
  'FABRIC',
  'MATERIAL',
  'CATEGORY',
  'STONE SHAPE',
  'JACKET STYLE',
  'LENGTH',
  'WARMTH',
  'ACTIVITY',
  'SLEEVE',
  'OCCASION',
]

export const SORT_BY = {
  FEATURED: {
    label: 'Featured',
    value: 'FEATURED',
  },
  PRICE_LOW_TO_HIGH: {
    label: 'Price Low',
    value: 'PRICE_LOW_TO_HIGH',
  },
  PRICE_HIGH_TO_LOW: {
    label: 'Price High',
    value: 'PRICE_HIGH_TO_LOW',
  },
  ALPHABETICALLY_A_Z: {
    label: 'Alphabetically: A-Z',
    value: 'ALPHABETICALLY_A_TO_Z',
  },
  ALPHABETICALLY_Z_A: {
    label: 'Alphabetically: Z-A',
    value: 'ALPHABETICALLY_Z_TO_A',
  },
  OLDEST_TO_NEWEST: {
    label: 'Oldest First',
    value: 'OLDEST_TO_NEWEST',
  },
  NEWEST_TO_OLDEST: {
    label: 'Newest First',
    value: 'NEWEST_TO_OLDEST',
  },
  BEST_SELLER: {
    label: 'Best Seller',
    value: 'BEST_SELLER',
  },
}

export const SORT_OPTIONS = [
  // SORT_BY.FEATURED,
  SORT_BY.PRICE_LOW_TO_HIGH,
  SORT_BY.PRICE_HIGH_TO_LOW,
  // SORT_BY.ALPHABETICALLY_A_Z,
  // SORT_BY.ALPHABETICALLY_Z_A,
  SORT_BY.BEST_SELLER,
  SORT_BY.OLDEST_TO_NEWEST,
  SORT_BY.NEWEST_TO_OLDEST,
]

export const FEATURED = {
  NEW_ARRIVALS: {
    label: 'New Arrivals',
    value: 'NEW_ARRIVALS',
  },
  BEST_SELLERS: {
    label: 'Best Sellers',
    value: 'BEST_SELLERS',
  },
}

export const FEATURED_OPTIONS = [FEATURED.NEW_ARRIVALS, FEATURED.BEST_SELLERS]
